/**
 * Static site chrome data (navigation, contact details, socials).
 * Navigation is overridable at runtime from the `nav_items` table via the admin.
 */

export type NavLink = {
  label: string;
  to: string;
  children?: NavLink[];
};

export const primaryNav: NavLink[] = [
  { label: "About", to: "/about" },
  {
    label: "Books",
    to: "/fire-carriers",
    children: [
      { label: "Fire Carriers", to: "/fire-carriers" },
      { label: "Fire Starters & Rain Crusaders", to: "/fire-starters-and-rain-crusaders" },
    ],
  },
  { label: "Crusades", to: "/crusades" },
  { label: "Donate", to: "/donate" },
  { label: "Join Us", to: "/join-us" },
  { label: "Contact", to: "/contact" },
];

export const footerNav: NavLink[] = [
  { label: "About Us", to: "/about" },
  { label: "Books", to: "/fire-carriers" },
  { label: "Crusades", to: "/crusades" },
  { label: "Donate", to: "/donate" },
  { label: "Join Us", to: "/join-us" },
  { label: "Contact Us", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy-policy" },
];

export const site = {
  name: "Light of Life International",
  shortName: "LOLI",
  tagline:
    "We are an evangelistic and compassion-driven ministry focused on bringing the transformative love of Jesus across the world.",
  logo: "/media/loli-full-logo-1.svg",
  address: "4364 Western Center Blvd #124 Fort Worth, Texas 76137",
  addressUrl: "https://maps.app.goo.gl/k2KzL8igs1ANiFLy8",
  phone: "682-232-4548",
  phoneHref: "tel:+16822324548",
  email: "info@loli.org",
  socials: [
    { label: "Facebook", href: "https://www.facebook.com/loliministries" },
    { label: "X", href: "https://x.com/loliministries" },
    { label: "YouTube", href: "https://www.youtube.com/user/loliministries/featured" },
  ],
  credit: { label: "Ardent Creative", href: "https://www.ardentcreative.com/" },
};
